import { getExtensionInternalStore } from "@openmrs/esm-extensions";
import { createUseStore } from "./useStore.js";
/** @internal
 * @deprecated Use `useStore(getExtensionInternalStore())`
 */ export const useExtensionInternalStore = createUseStore(getExtensionInternalStore());
